(function ($) {
    'use strict';
    $(document).ready(function () {
        /* Initialize our various swiper blocks */

        // Brands Carousel block
        var brandsCarousels = $('.brands-carousel-section');
        // check if swiperContainer div exist
        if (typeof brandsCarousels !== 'undefined' && brandsCarousels !== null) {
            window.brandsCarouselsInstances = [];
            $.each($('.brands-carousel-section .wp-block-gallery'), function () {
                var brandsCarouselsInstance = new Swiper($(this), {
                    slidesPerView: 4,
                    slideClass: 'blocks-gallery-item',
                    wrapperClass: 'blocks-gallery-grid',
                    speed: 800,
                    spaceBetween: 0,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    loop: true,
                    observer: true,
                    observeParents: true,
                    breakpoints: {
                        // when window width is >= 0px
                        0: {
                            slidesPerView: 1,
                        },
                        // when window width is >= 992px
                        991: {
                            slidesPerView: 4,
                        },
                    },
                });

                window.brandsCarouselsInstances.push(brandsCarouselsInstance);
            });
        }
        // window.brandsCarouselsInstances[0].destroy();

        // insight Carousel block
        if (window.currentBreakPoint !== 'lg' && window.currentBreakPoint !== 'xl') {
            var insightsCarousels = $('.insight-section');
            // check if swiperContainer div exist
            if (typeof insightsCarousels !== 'undefined' && insightsCarousels !== null) {
                window.insightsCarouselsInstances = [];
                $.each($('.insight-section .wp-block-latest-posts-container'), function () {
                    $(this).append('<!-- Added by JS pagination -->\n' + '<div class="swiper-pagination"></div>');
                    var insightsCarouselsInstance = new Swiper($(this), {
                        slidesPerView: 1,
                        slideClass: 'lastest-post-v2-item',
                        wrapperClass: 'wp-block-latest-posts',
                        centeredSlides: true,
                        speed: 800,
                        spaceBetween: 0,
                        autoplay: {
                            delay: 3000,
                            disableOnInteraction: true,
                        },
                        pagination: {
                            el: $(this).children('.swiper-pagination'),
                            clickable: true,
                        },
                        loop: true,
                        observer: true,
                        observeParents: true,
                        breakpoints: {
                            // when window width is >= 0px
                            0: {
                                slidesPerView: 1,
                            },
                            // when window width is >= 992px
                            991: {
                                slidesPerView: 1,
                            },
                        },
                    });

                    window.insightsCarouselsInstances.push(insightsCarouselsInstance);
                });
            }
            // window.insightsCarouselsInstances[0].destroy();
        }
    });

    $(window).load(function () {});
})(jQuery);
